import { IconProps } from './types'

export const BuildingPlaceholderIcon = ({ size = 14, color = 'currentColor', id, ...props }: IconProps) => (
  <svg viewBox='0 0 24 22' id={id} style={{ width: size, height: size, flexShrink: 0 }} fill='none' {...props}>
    <path d='M12 0L24 6V8H0V6L12 0Z' fill={color} />
    <rect x='2' y='9' width='3' height='10' fill={color} />
    <rect x='7' y='9' width='3' height='10' fill={color} />
    <rect x='14' y='9' width='3' height='10' fill={color} />
    <rect x='19' y='9' width='3' height='10' fill={color} />
    <rect x='0' y='19' width='24' height='3' fill={color} />
  </svg>
)
